import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { down } from "styled-breakpoints"
import { Container } from "../../utils/utils"

const NavbarHeader = styled.div`
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: ${props => props.bgColor || props.theme.color.prim1};

  ${down("sm")} {
    display: none;
  }
`

const NavbarInfo = styled(Container)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
`

const NavbarLeft = styled.div`
  justify-self: left;

  p {
    color: ${({ theme }) => theme.color.white};
    font-weight: 500;
    line-height: 1;
  }
`

const NavbarRight = styled.div`
  justify-self: right;

  a {
    text-align: right;
    font-weight: 500;
    color: ${({ theme }) => theme.color.white};
    font-size: 25px;
    margin-left: 1rem;
  }
`

const NavbarHeaderCentered = props => {
  let slugWithoutlocale =
    props.slug === null || props.slug === undefined
      ? ""
      : props.slug
          .replace(/^\/?en/, "")
          .replace(/^\//, "")
          .replace(/\/+$/, "")

  let plSlug = "/" + slugWithoutlocale
  let enSlug = "/en/" + slugWithoutlocale

  // usuwanie podwojnych slashy
  plSlug = plSlug.replace(/\/{2,}/, "")
  enSlug = enSlug.replace(/\/{2,}/, "")

  return (
    <NavbarHeader bgColor={props.bgColor}>
      <NavbarInfo>
        <NavbarLeft>
          {/* <p>+48 {props.tel}</p>
                    <p>{props.email}</p> */}
        </NavbarLeft>

        <NavbarRight>
          <Link to={plSlug}>PL</Link>
          <Link to={enSlug}>EN</Link>
        </NavbarRight>
      </NavbarInfo>
    </NavbarHeader>
  )
}
export default NavbarHeaderCentered
